var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xs":"","ma-0":"","pa-0":"","fluid":""}},[_vm._t("default",[_vm._v("\n    "+_vm._s(_vm.data)+"\n  ")],{"args":_vm.args,"data":_vm.data,"loading":_vm.loading})],2)}
var staticRenderFns = []

export { render, staticRenderFns }